import { Alpine } from "../../../vendor/livewire/livewire/dist/livewire.esm";
Alpine.data('urlUpdater', () => ({
    updateUrl(newPath) {
        if (location.pathname !== newPath) {
            history.replaceState({}, '', newPath);
        }
    }
}));
